export const routes = [
  {
    path: "/",
    component: () => import("@/pages/WelcomePage/WelcomePage.vue"),
    meta: {
      requiresAuth: true,
    },
    name: "home",
  },
  //Business Settings
  {
    path: "/business_settings",
    component: () =>
      import("@/pages/UserSettings/BusinessSettings/BusinessSettings.vue"),
    meta: {
      requiresAuth: true,
    },
    name: "businessSettings",
  },
  {
    path: "/permission_management",
    component: () =>
      import("@/pages/PermissionsManagement/PermissionsManagement.vue"),
    meta: {
      requiresAuth: true,
    },
    name: "permissionsManagement",
  },
  {
    path: "/portal_credentials",
    component: () =>
      import("@/pages/PortalCredentialManager/PortalCredentialManager.vue"),
    meta: {
      requiresAuth: true,
    },
    name: "portalCredentialsManagement",
  },
  //Backoffice Settings
  {
    path: "/backoffice_settings",
    component: () =>
      import("@/pages/UserSettings/BackofficeSettings/BackofficeSettings.vue"),
    meta: {
      requiresAuth: true,
    },
    name: "backofficeSettings",
  },
  //File Mappings
  {
    path: "/file_mappings",
    component: () => import("@/pages/FileMappingsV2/FileMappings.vue"),
    meta: {
      requiresAuth: true,
    },
    name: "fileMappings",
  },
  //FileUploads
  {
    path: "/file_uploads/",
    component: () => import("@/pages/FileUploads/FileUploads.vue"),
    meta: {
      requiresAuth: true,
    },
    props: true,
    name: "fileUploads",
  },
  {
    path: "/file_uploads/:propDate",
    redirect: "/file_uploads",
  },
  //Product Management
  {
    path: "/product_management",
    component: () => import("@/pages/ProductManagement/ProductManagement.vue"),
    meta: {
      requiresAuth: true,
    },
    name: "productManagement",
  },
  //Validations
  {
    path: "/validations",
    component: () =>
      import("@/pages/PendingValidations/PendingValidations.vue"),
    meta: {
      requiresAuth: true,
    },
    name: "pendingValidations",
  },
  //Warehouse Management
  {
    path: "/warehouse_management",
    component: () => import("@/pages/Warehouses/WarehouseManagement.vue"),
    meta: {
      requiresAuth: true,
    },
    name: "warehouseManagement",
  },
  //Store Management
  {
    path: "/store_management",
    components: {
      default: () => import("@/pages/StoreManagement/StoreManagement.vue"),
      optionalDrawer: () =>
        import("@/pages/StoreManagement/components/filters.vue"),
    },
    meta: {
      requiresAuth: true,
    },
    name: "storeManagement",
  },
  //Phantom Stock
  {
    path: "/phantom_stock",
    components: {
      default: () => import("@/pages/PhantomStock/PhantomStock.vue"),
      optionalDrawer: () =>
        import("@/pages/PhantomStock/components/filters.vue"),
    },
    meta: {
      requiresAuth: true,
    },
    name: "phantomStock",
  },
  //Cardex
  {
    path: "/cardex",
    components: {
      default: () => import("@/pages/Cardex/Cardex.vue"),
      optionalDrawer: () => import("@/pages/Cardex/components/filters.vue"),
    },
    meta: {
      requiresAuth: true,
    },
    name: "cardex",
  },
  //Automatic orders
  {
    path: "/automatic_order",
    components: {
      default: () => import("@/pages/AutomaticOrder/AutomaticOrder.vue"),
      optionalDrawer: () =>
        import("@/pages/AutomaticOrder/components/filters.vue"),
    },
    meta: {
      requiresAuth: true,
    },
    name: "automaticOrder",
  },
  //Sellers
  {
    path: "/sellers",
    components: {
      default: () => import("@/pages/Sellers/Sellers.vue"),
    },
    meta: {
      requiresAuth: true,
    },
    name: "sellers",
  },
  //Login
  {
    path: "/login",
    components: {
      default: () => import("@/pages/LoginScreen/LoginScreen.vue"),
    },
    name: "loginPage",
    meta: {
      requiresAuth: false,
    },
  },
  //Verification & Recovery
  {
    path: "/account_actions/:action/:token",
    components: {
      default: () => import("@/pages/AccountActions/AccountActions.vue"),
    },
    props: {
      default: true,
    },
    name: "accountActions",
  },
  //Profile Management
  {
    path: "/profile_management",
    components: {
      default: () => import("@/pages/UserProfile/UserProfile.vue"),
    },
    name: "profileManagement",
    meta: {
      requiresAuth: true,
    },
  },
  //User Management
  {
    path: "/user_management",
    components: {
      default: () => import("@/pages/UserManagement/UserManagement.vue"),
    },
    name: "userManagement",
    meta: {
      requiresAuth: true,
    },
  },
  //Field Sales
  {
    path: "/dashboard/field_sales/:secTab",
    components: {
      default: () => import("@/pages/SalesDashboard/SalesDashboard.vue"),
      optionalDrawer: () =>
        import("@/pages/SalesDashboard/components/filters.vue"),
    },
    name: "fieldSales",
    props: {
      default: true,
    },
    meta: {
      requiresAuth: true,
    },
  },
  //Flash Report
  {
    path: "/dashboard/flash_report/:secTab",
    components: {
      default: () => import("@/pages/FlashReport/FlashReport.vue"),
      optionalDrawer: () =>
        import("@/pages/FlashReport/components/filters.vue"),
    },
    name: "flashReport",
    props: {
      default: true,
    },
    meta: {
      requiresAuth: true,
    },
  },
  // Dashboard
  {
    path: "/dashboard/argh",
    components: {
      default: () =>
        import("@/pages/FlashReport/components/ProductDistributionTab.vue"),
      optionalDrawer: () =>
        import("@/pages/FlashReport/components/filters.vue"),
    },
    name: "productDistribution",
    meta: {
      requiresAuth: true,
    },
  },
  //DataBuilder
  {
    path: "/data_builder",
    components: {
      default: () => import("@/pages/MyPivot/MyPivot.vue"),
    },
    name: "dataBuilder",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/data_builder/:token",
    redirect: "/data_builder",
  },
  //Classification Hierarchies
  {
    path: "/classification_hierarchies",
    components: {
      default: () =>
        import("@/pages/Hierarchies/Classification/Hierarchies.vue"),
    },
    name: "classificationHierarchies",
    meta: {
      requiresAuth: true,
    },
  },
  //Designation Hierarchies
  {
    path: "/designation_hierarchies",
    components: {
      default: () => import("@/pages/Hierarchies/Designation/Hierarchies.vue"),
    },
    name: "designationHierarchies",
    meta: {
      requiresAuth: true,
    },
  },
  //Automatic Uploads
  {
    path: "/automatic_uploads",
    components: {
      default: () => import("@/pages/AutomaticUploads/AutomaticUploads.vue"),
    },
    name: "AutomaticUploads",
    meta: {
      requiresAuth: true,
    },
  },
];
